// extracted by css-extract-rspack-plugin
export default {"cls1":"StatCells-cls1_gvs","cls2":"StatCells-cls2_Qjl StatCells-cls1_gvs","cellStyle-delta_chip":"StatCells-cellStyle-delta_chip_hlv"};